const MAX_MENU_IMAGE_BYTES = 1024 * 1024;

function loadImageFromFile(file) {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error('Could not read the selected image.'));
        };
        img.src = url;
    });
}

function createScaledCanvas(img, maxDimension) {
    const scale = Math.min(1, maxDimension / Math.max(img.width, img.height, 1));
    const width = Math.max(1, Math.round(img.width * scale));
    const height = Math.max(1, Math.round(img.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);
    return canvas;
}

function canvasToWebpBlob(canvas, quality) {
    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (blob) resolve(blob);
                else reject(new Error('Failed to convert image to WebP.'));
            },
            'image/webp',
            quality
        );
    });
}

/**
 * Convert a menu image file to WebP and compress until it is under 1 MB.
 * @param {File} file
 * @returns {Promise<File>}
 */
export async function processMenuImageFile(file) {
    if (!file || !String(file.type || '').startsWith('image/')) {
        throw new Error('Please select a valid image file.');
    }

    const img = await loadImageFromFile(file);
    let maxDim = 2048;
    let quality = 0.85;

    while (maxDim >= 400) {
        const canvas = createScaledCanvas(img, maxDim);
        let q = quality;
        while (q >= 0.5) {
            const blob = await canvasToWebpBlob(canvas, q);
            if (blob.size <= MAX_MENU_IMAGE_BYTES) {
                const baseName = String(file.name || 'menu-image').replace(/\.[^.]+$/, '');
                return new File([blob], `${baseName}.webp`, { type: 'image/webp' });
            }
            q = Math.round((q - 0.1) * 10) / 10;
        }
        maxDim = Math.floor(maxDim * 0.75);
    }

    throw new Error('Could not compress image below 1 MB. Please use a smaller image.');
}

export async function ensureMenuImageFile(file) {
    if (!file) return null;
    if (
        file.type === 'image/webp' &&
        file.size > 0 &&
        file.size <= MAX_MENU_IMAGE_BYTES
    ) {
        return file;
    }
    return processMenuImageFile(file);
}
